import { z } from 'zod';

import { VisibilitySettingStyle } from './visibility-setting-style';

export const CmsUrlOptions = z.object({
  visibilityClass: z.nullable(VisibilitySettingStyle).optional(),
  attributes: z.object({
    target: z.number(),
    rel: z.string().optional(),
    class: z.string().optional(),
  }),
});

export type CmsUrlOptions = z.infer<typeof CmsUrlOptions>;

export const CmsUrlFields = z.object({
  uri: z.string(),
  title: z.string().optional(),
  options: CmsUrlOptions,
});

export type CmsUrlFields = z.infer<typeof CmsUrlFields>;

export const CmsUrl = z.array(CmsUrlFields);

export type CmsUrl = z.infer<typeof CmsUrl>;
